import { useQuery } from "react-query";
import { fetchVendorCategories } from "../actions/vendor";

export const useVendorCategory = () => {
	return useQuery("vendorCategories", fetchVendorCategories, {
		refetchOnWindowFocus: false,
	});
};
